var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { tvAuthService } from '../../../services/TvAuthService';
import { withTranslation } from 'react-i18next';
var SetLoginId = (function (_super) {
    __extends(SetLoginId, _super);
    function SetLoginId(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNumberChange = function (event) {
            _this.setState({ loginId: event.target.value, isValidNumber: '' });
        };
        _this.callIfEnter = function (event, callback) {
            if (event && event.key === 'Enter' && callback && callback instanceof Function) {
                var loginId = _this.state.loginId;
                {
                    (loginId && _this.isValidPhone(loginId.replace(/[^\d]/g, '')) ? _this.setState({ isValidNumber: true }) : _this.setState({ isValidNumber: false }));
                }
                callback(loginId);
            }
        };
        _this.getUrlParams = function (params) {
            var urlParams = new URLSearchParams(location.search.replace('#/', ''));
            return urlParams && urlParams.get(params) || '';
        };
        _this.state = {
            activeStep: 1,
            loginId: _this.props.msisdn || '',
            isValidNumber: (_this.props.msisdn && _this.isValidPhone(_this.props.msisdn.replace(/[^\d]/g, ''))) || ''
        };
        return _this;
    }
    SetLoginId.prototype.renderButton = function () {
        var _a = this.props, t = _a.t, onClick = _a.onClick;
        var loginId = this.state.loginId;
        return (React.createElement("div", { className: "s20-form-buttons s20-form-buttons--right" },
            React.createElement("div", { className: "s20-form-buttons__item" },
                React.createElement("button", { className: "s20-button", type: "button", onClick: function () { return onClick(loginId); }, disabled: !loginId }, t("SetLogin.Number.Submit")))));
    };
    SetLoginId.prototype.handleBlur = function () {
        var loginId = this.state.loginId;
        {
            (loginId && this.isValidPhone(loginId.replace(/[^\d]/g, '')) ? this.setState({ isValidNumber: true }) : this.setState({ isValidNumber: false }));
        }
    };
    SetLoginId.prototype.isValidPhone = function (phoneNumber) {
        var regExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im;
        return regExp.test(phoneNumber);
    };
    SetLoginId.prototype.renderInput = function () {
        var _this = this;
        var _a = this.props, t = _a.t, onClick = _a.onClick, errorCode = _a.errorCode;
        var _b = this.state, loginId = _b.loginId, isValidNumber = _b.isValidNumber;
        var addClass = '';
        if (loginId && isValidNumber !== '') {
            ((!isValidNumber || errorCode === 'LOGIN_NAME_ALREADY_USED') ? addClass = 'is-error' : addClass = 'is-success');
        }
        return (React.createElement("div", { className: "s20-form-item has-no-bottom-margin " + addClass },
            React.createElement("div", { className: "s20-form-input s20-form-input--text s20-form-input--md" },
                React.createElement("label", { className: "s20-form-label", htmlFor: "phone" }, t("SetLogin.Number.Label")),
                React.createElement("input", { name: 'loginId', type: 'tel', id: 'phone', value: tvAuthService.formatUsername(loginId), className: 's20-form-input__field', onBlur: function () { return _this.handleBlur(); }, onChange: this.handleNumberChange, onKeyDown: function (event) { return _this.callIfEnter(event, function () { return onClick(loginId); }); }, maxLength: 13, autoComplete: 'off' }),
                (errorCode === 'LOGIN_NAME_ALREADY_USED' && isValidNumber) ? React.createElement("div", { className: 's20-form-note' }, t("SetLogin.Number.AlreadyUsed")) : addClass === 'is-error' ? React.createElement("div", { className: 's20-form-note' }, t("SetLogin.Number.Error")) : null)));
    };
    SetLoginId.prototype.renderLoginField = function () {
        var t = this.props.t;
        var tvSubscriberId = this.getUrlParams('subscriptionId') || '';
        return (React.createElement("div", { className: "l-center-s" },
            React.createElement("h3", { className: "s20-teaser-title s20-teaser-title--regular" }, t("SetLogin.Number.Title")),
            React.createElement("div", { className: "s20-spacer s20-spacer--x12 is-hidden-mobile" }),
            React.createElement("div", { className: "s20-spacer s20-spacer--x8 is-hidden-desktop" }),
            this.renderInput(),
            React.createElement("div", { className: "s20-spacer s20-spacer--x20 is-hidden-mobile" }),
            React.createElement("div", { className: "s20-spacer s20-spacer--x12 is-hidden-desktop" }),
            this.renderButton()));
    };
    SetLoginId.prototype.handleError = function () {
        var _a = this.props, t = _a.t, errorCode = _a.errorCode;
        if (errorCode === 'LOGIN_NAME_ALREADY_USED') {
            return null;
        }
        return (React.createElement("div", { className: 'form_alert form_alert-error', role: 'alert' },
            React.createElement("h2", { className: 'form_alert--heading' }, t("SetPassword.Error.Title")),
            React.createElement("div", { className: 'form_alert__flex_container' },
                React.createElement("div", null,
                    React.createElement("i", { className: 'form_alert--icon icon' })),
                React.createElement("div", { className: 'form_alert--list--content' },
                    React.createElement("ul", { className: 'form_alert--list' },
                        React.createElement("li", null,
                            React.createElement("a", null, errorCode ? t("SetPassword.Error." + errorCode) : t("SetPassword.Error.Label"))))))));
    };
    SetLoginId.prototype.render = function () {
        var isError = this.props.isError;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'l-center-m' },
                React.createElement("div", { className: 'content_box' },
                    isError ? this.handleError() : null,
                    this.renderLoginField()))));
    };
    return SetLoginId;
}(React.Component));
export default withTranslation()(SetLoginId);
